import type { Lang } from "./types"

// English/Spanish presentational split for the Website editing screens. Uses
// the design system's toggle-button pattern (see the Analytics brand filter).
export function LanguageToggle({
  lang,
  onChange,
  staleCount = 0,
}: {
  lang: Lang
  onChange: (lang: Lang) => void
  staleCount?: number
}) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <button type="button" className="toggle-button" aria-pressed={lang === "en"} onClick={() => onChange("en")}>
        English
      </button>
      <button type="button" className="toggle-button" aria-pressed={lang === "es"} onClick={() => onChange("es")}>
        Español{staleCount > 0 ? ` · ${staleCount} out of date` : ""}
      </button>
    </div>
  )
}
